import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ProjectTrackingWidget from '../../../widgets/adminReport/ProjectTracking/ProjectTrackingWidget'
import { getProjectfollowuplist } from '../../../redux/actions/adminReport'

export default function ProjectTracking(props) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getProjectfollowuplist()
      _schema.form.searchObject.textByConditions = textByConditions
      console.log('_schema ', _schema)
      setSchema(_schema)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    // console.log('load AllProjectSummaryReport')
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  return (
    <SidebarProposal isReport>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

      <ProjectTrackingWidget schema={schema.form.searchObject} />
    </SidebarProposal>
  )
}

const textByConditions = {
  name: 'textByConditions',
  label: 'ระบุ',
  hint: 'ระบุ',
  value: '',
  validators: [
    {
      type: 'REQUIRED',
      value: null,
      errorMessage: 'กรุณากรอก เงื่อนไขเพิ่มเติม',
    },
  ],
}
